<script lang="ts">
  /**
   * A pair of scales, drawn rather than sourced.
   *
   * # Why not a file
   *
   * Every stock scales-of-justice carries a licence, and a line drawing is
   * the one case where sourcing one buys nothing: the whole image is a dozen
   * strokes. Drawing it keeps the page free of an attribution question, and
   * it inherits the site's own line language — `currentColor`, round caps,
   * the same stroke weight as `icon.svelte` — which no downloaded SVG would.
   *
   * It also scales. A raster at hero size would need a 2x asset and would
   * still blur on a 3x phone.
   *
   * # The beams are level on purpose
   *
   * A tilted balance is the visual language of a verdict — one side wins.
   * This page does not decide anything; it says which of two laws answers
   * which question, and that both must be satisfied. Level pans say "two
   * things weighed together", which is the page's actual argument.
   *
   * Decorative, so `aria-hidden`: the heading beside it already names the
   * subject, and a screen reader announcing "scales" adds nothing.
   */
  let { class: extra = '' }: { class?: string } = $props();
</script>

<svg
  class={extra}
  viewBox="0 0 120 120"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  <!-- Column and foot -->
  <path d="M60 22v74" />
  <path d="M44 104h32" />
  <path d="M52 96h16l8 8H44z" />

  <!-- Finial -->
  <circle cx="60" cy="18" r="4" />

  <!-- The beam, level -->
  <path d="M20 34h80" />

  <!-- Cords to each pan -->
  <path d="M28 34l-8 18M28 34l8 18" />
  <path d="M92 34l-8 18M92 34l8 18" />

  <!-- Pans -->
  <path d="M12 52h32a16 16 0 01-32 0z" />
  <path d="M76 52h32a16 16 0 01-32 0z" />

  <!-- Hangers -->
  <path d="M28 34v-4" />
  <path d="M92 34v-4" />
</svg>
